import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import SwiperHeader from "../DefaultSwiper/SwiperHeader";
import isMobile from "ismobilejs";
import "swiper/swiper.scss";
import styled from "styled-components";
import ImageGrid from "./ImageGrid";

const DefaultSwip = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  padding-left: 49px;
  gap: 40px;
  width: 100%;
  .swiper-container {
    width: 100%;
    margin: 0;
    padding-right: 49px;

    @media (max-width: 768px) {
      width: 110%;
      padding-left: 16px;
    }
  }
  .swiper-wrapper {
    width: 100%;
    .swiper-slide {
      width: 100% !important;
    }
  }

  @media (max-width: 768px) {
    padding-left: 16px;
    gap: 20px;
  }
`;
function GridSwiper({
  slides,
  main,
  sub,
  addcircuit,
  local,
  getSafe,
  cityfilter,
  filter,
}) {
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [circuitGrid, setCircuitGrid] = React.useState([]);
  useEffect(() => {
    let output = getSafe(() => slides);
    if (filter && Array.isArray(filter)) {
      output = slides.filter(
        (p) =>
          filter.indexOf(p.tags[0]?.slug) > -1 ||
          filter.indexOf(p.tags[1]?.slug) > -1 ||
          filter.indexOf(p.tags[2]?.slug) > -1
      );
    }
    if (cityfilter && Array.isArray(cityfilter)) {
      output = slides.filter((p) => cityfilter.indexOf(p.cities[0].slug) > -1);
    }

    var index = 0;
    var arrayLength = output ? output.length : 0;
    var tempArray = [];

    for (index = 0; index < arrayLength; index += 3) {
      let myChunk = output.slice(index, index + 3);
      tempArray.push(myChunk);
    }

    setCircuitGrid(tempArray);
  }, [slides, cityfilter, filter, getSafe]);
  SwiperCore.use([Navigation]);
  return (
    <DefaultSwip>
      {
        <SwiperHeader
          navigationPrevRef={navigationPrevRef}
          navigationNextRef={navigationNextRef}
          todoPlaces={circuitGrid}
          main={main}
          sub={sub}
        />
      }

      {getSafe(() => circuitGrid.length) > 0 && (
        <Swiper
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          beforeInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          onSwiper={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          observer={true}
          observerParents={true}
          allowTouchMove={isMobile().phone ? true : false}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          spaceBetween={isMobile().phone ? 50 : 100}
          slidesPerView={1}
        >
          {circuitGrid.map((slide, i) => (
            <SwiperSlide key={i}>
              <ImageGrid
                addcircuit={addcircuit}
                slide={slide}
                local={local}
                getSafe={getSafe}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </DefaultSwip>
  );
}

export default GridSwiper;
